<template>
  <div id="manual">
    <router-view/>
    <div class="btn_close" @click="closeWindow">창닫기</div>
  </div>
</template>

<script>
import '../../css/manual.css'

export default {
  methods: {
    closeWindow () {
      window.close()
    }
  }
}
</script>

<style scoped>
#manual .btn_close {
  width: 200px;
  height: 56px;
  border-radius: 4px;
  margin: 24px auto;
  background: #E9E9E9;
  color: #36414F;
  font-size: 14px;
  font-weight: 700;
  line-height: 56px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/manual/Manual.vue